'use strict';

import PayloadSources from './constants/PayloadSources';
import { Dispatcher } from 'flux';
import assign from 'react/lib/Object.assign';
import ActionTypes from './constants/ActionTypes';
import CrashReporter from 'CrashReporter';
import camelizeAction from './utils/camelizeAction';
import logAction from './utils/logAction';

const AppDispatcher = assign(new Dispatcher(), {
  handleViewAction: CrashReporter.wrap(function handleViewAction(action) {
    logAction('->', action);

    if (!action.type) {
      throw new Error('Empty action.type: you likely mistyped the action.');
    }

    this.dispatch({
      source: PayloadSources.VIEW_ACTION,
      action: action
    });
  }),

  handleServerAction: CrashReporter.wrap(function handleServerAction(action) {
    action = camelizeAction(action);
    logAction('<-', action);

    if (!action.type) {
      throw new Error('Empty action.type: you likely mistyped the action.');
    }

    this.dispatch({
      source: PayloadSources.SERVER_ACTION,
      action: action
    });
  }),

  handleServerFormAction: CrashReporter.wrap(function handleServerFormAction(action) {
    this.handleServerAction(action);
    this.handleServerAction({
      type: action.err ? ActionTypes.SUBMIT_FORM_ERROR : ActionTypes.SUBMIT_FORM_SUCCESS,
      messages: action.err && action.err.body
    });
  }),

  handlePreloadedAction: CrashReporter.wrap(function handlePreloadedAction(action) {
    action = camelizeAction(action);
    logAction('--', action);

    this.dispatch({
      source: PayloadSources.PRELOADED_ACTION,
      action: action
    });
  })
});

export default AppDispatcher;



/** WEBPACK FOOTER **
 ** ./AppDispatcher.js
 **/